export const INSTANCE_ICONS = ["🎯", "💼", "🚀", "💰", "📈", "🔥", "⭐", "🌟", "💎", "🎪"];
export const INSTANCE_COLORS = ["#00A38A", "#3b82f6", "#8b5cf6", "#f59e0b", "#10b981", "#ef4444", "#6366f1", "#ec4899"];
export const DEFAULT_ICON = "🎯";
export const DEFAULT_COLOR = "#00A38A";

export const formatGoal = (value) => {
  if (!value) return "No goal set";
  if (value >= 1_000_000_000) return `$${(value / 1_000_000_000).toFixed(1)}B`;
  if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `$${(value / 1_000).toFixed(0)}K`;
  return `$${value.toFixed(0)}`;
};
